module.exports = __webpack_public_path__ + "static/media/APP_EarlyRiser_152x174_5.08a151f3.png";